export default "__VITE_ASSET__cRnh9O_P__"